<template>
  <div v-if="content.target" :class="content.target.size?.sm?.fullWidth ? 'w-full' : 'w-fit'">
    <cms-shared-button ref="elementRef" v-bind="content.target" @click="handleClick" />
  </div>
</template>

<script lang="ts" setup>
import type { CtaButtonContent } from '#types/components/cms/cta-button'
import { ParentPromotionTrackingKey } from '#content/contexts/promotionTracking'

const { content, index = 0 } = defineProps<{ content: CtaButtonContent, index?: number }>()

const { parentPromotionName, parentHandlePromotionClick } = inject(ParentPromotionTrackingKey, {})

const {
  elementRef,
  handlePromotionClick
} = usePromotionTracking(content.promotionTracking, content.name, parentPromotionName)

const handleClick = () => {
  handlePromotionClick(`cta1`)
  parentHandlePromotionClick && parentHandlePromotionClick(`cta${index + 1}`)
}
</script>
